import Tip from "./tip";

export default Tip;
